import React from 'react';
import { CheckIcon } from 'lucide-react';
interface FeaturePointRlt1Props {
  children: React.ReactNode;
}
const FeaturePointRlt1 = ({
  children
}: FeaturePointRlt1Props) => {
  return <div className="flex items-start" data-id="element-16950" data-mp="1xnx9shs7dsci">
      <div className="flex-shrink-0 mt-1" data-id="element-16951" data-mp="1xmul8gics1zr">
        <CheckIcon className="h-4 w-4 text-gray-700" data-id="element-16952" data-mp="1xq061jjy8hpo" />
      </div>
      <div className="ml-2 text-sm text-gray-700" data-id="element-16953" data-mp="22obim21mp6bl">{children}</div>
    </div>;
};
export default FeaturePointRlt1;